import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import PortalAccount from './portal-account.jsx';
export default class PortalAccountsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      portal_accounts: props.portal_accounts || [],
      isLoading: true,
      url: props.url || null,
      play: false,
      hasMore:true,
      page:1,
      isUpdatingRow : false
    };
    this.handleScroll = this.handleScroll.bind(this);
    Echo.channel('portal-admin-table')
      .listen('PortalAccountsTableChanged', (e) => {
        // this.getPortalAccounts();
        this.setState({isUpdatingRow:true});
        if(e.userId && this.state.isUpdatingRow){
          fetch('/api/v1/portal/portal-admin/users/view/'+e.userId, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token
              ,"Accept": 'application/json'
            },
          }).then((responseText) => {
            let response = responseText.json();
            response.then((portalAccountsJson) => {
              if(portalAccountsJson.data && portalAccountsJson.data[0] && this.state.portal_accounts){
                let Updateindex = this.state.portal_accounts.findIndex(account => account.id == e.userId);
                if(Updateindex != -1){
                  this.state.portal_accounts[Updateindex] = portalAccountsJson.data[0];
                  this.setState({portal_accounts:this.state.portal_accounts,isUpdatingRow:false});
                }
              }
            });
          });
        }
        
      });
    
  }
  getPortalAccounts() {
    if (this.state.url !== null && this.state.isLoading == true) {
      return fetch(this.state.url+'?page='+this.state.page, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          ,"Accept": 'application/json'
        },
      }).then((responseText) => {
        let response = responseText.json();
        response.then((portalAccountsJson) => {
          if(portalAccountsJson.data.length == 0){
            this.setState({hasMore: false});
          }
          this.setState({
            portal_accounts: [
              ...this.state.portal_accounts,
              ...portalAccountsJson.data,
            ],
            // portal_accounts: portalAccountsJson,
            isLoading: false,
            url: this.state.url,
            page: portalAccountsJson.current_page+1
          })
        });
      });
    }
    return false;
  }
  componentDidMount() {
    if (this.state.isLoading || !this.state.portal_accounts) {
      this.getPortalAccounts();
    }
    this.setState({
      play: true
    });
  }
  componentWillMount() {
    //if (this.state.infiniteScroll === true) {
      window.addEventListener(
        'scroll',
        this.handleScroll
      );
    //}
  }
  componentWillUnmount() {
    //if (this.state.infiniteScroll === true) {
      window.removeEventListener(
        'scroll',
        this.handleScroll
      );
    //}
  }
  toggleColumnsToggleOptions() {
    document.querySelector(
      '.columns-toggle-options'
    ).classList.toggle(
      'display-block'
    );
  }
  handleScroll() {
    if ((window.innerHeight + document.scrollingElement.scrollTop + 10
        ) >= document.documentElement.offsetHeight) {
    if(this.state.hasMore){
      this.setState({
        isLoading: true
      });
      this.getPortalAccounts();
      }
    }
  }
  render() {
    let PortalAccountsTable = [];
    let accountIds = [];
    if (this.state.portal_accounts && this.state.portal_accounts.length > 0) {
      this.state.portal_accounts.forEach(function(i,index) {
        var filterRow = accountIds.findIndex(x => x.id == i.id);
        if ((i && i.id) && (filterRow <= -1)) {
          accountIds.push({id: i.id});
          PortalAccountsTable.push(
            <PortalAccount
              key={'portal-account-id-' + i.id+'-'+index}
              data={i}
            />
          );
        }
      });
    }
    else {
      PortalAccountsTable = this.props.message_if_none;
    }
    return (
      <Animate
        play={this.state.play}
        start={{opacity: 0}}
        end={{opacity: 1}}
      >
      <div className="portal-admin-table">
      <div className="columns-toggle">
      <div className="columns-toggle-options">
      <label htmlFor="hide-id">
        <input
          type="checkbox"
          id="hide-id"
          defaultChecked
          onClick={() => {
            $('.column-type-job-id').fadeToggle()
          }}
        /> #</label>
      <label htmlFor="hide-company">
        <input
          type="checkbox"
          id="hide-company"
          defaultChecked
          onClick={() => {
            $('.column-type-company').fadeToggle()
          }}
        /> Company</label>
      <label htmlFor="hide-full-details">
        <input
          type="checkbox"
          id="hide-full-details"
          defaultChecked
          onClick={() => {
            $('.column-type-full-details').fadeToggle()
          }}
        /> Full Details</label>
      </div>
      <button className="btn btn-sml btn-default"
              onClick={this.toggleColumnsToggleOptions}>
        <i className="fa fa-columns"></i> Columns
      </button>
      </div>
      <div className="portal-admin-table-row header">
      <div className="cell column-type-job-id">#</div>
      <div className="cell column-type-company">Company</div>
      <div className="cell column-type-photo">Photo</div>
      <div className="cell column-type-name">Name</div>
      <div className="cell column-type-email">Email</div>
      <div className="cell column-type-created-at">created at </div>
      <div className="cell column-type-last-login">last login</div>
      <div className="cell column-type-account-status">Account Status</div>
      <div className="cell column-type-is-driver-archieved">Archived?</div>
      <div className="cell column-type-full-details"></div>
      </div>
      {
        PortalAccountsTable.length > 0 ? 
          (this.state.page == 1 && this.state.isLoading) ? null : PortalAccountsTable
          :
        ""
      }
      {
        this.state.isLoading ?
        (<div className="loading-box">
          <span className="add-loading-text">
            <i className="fa fa-spinner fa-pulse"></i>
          </span>
        </div>) :
          null
      }
      {(this.state.hasMore) ?
          null
          :
          <div className="text-center no-more">
            <h1>
              No more accounts.
            </h1>
          </div>
        }
      </div>
      </Animate>
    );
  }
}

